// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_ooR","cls2":"ProfilePdfPackCard-cls2_NWS ProfilePdfPackCard-cls1_ooR"};